/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { FormikProps, useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { savePowerPosition } from "../../../redux/Action/Action";
import { RootState } from "../../../redux/Reducer";
import { SET_POWER_POSITION } from "../../../redux/Action/actionTypes";

type Props = {
  setRefInstance: (instance: FormikProps<any> | null) => void;
  setIsSubmitDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  powerPositionIdHandler:(typeName:string) => void
};

interface LocalFields {
  supplierExistOrNot: string | boolean;
  supplierAwareness: string | boolean;
  supplierDependent: string | boolean;
}

const PowerPositionQuestionnaire = ({
  setRefInstance,
  setIsSubmitDisabled,
  powerPositionIdHandler
}: Props) => {
  const dispatch = useDispatch();

  // fetching the powerposition data from redux store
  const powerPostionData = useSelector(
    (state: RootState) => state.powerPosition.powerPositionData
  );

  //initial values of formik
  const LocalFields: LocalFields = {
    supplierExistOrNot: "",
    supplierAwareness: "",
    supplierDependent: "",
  };

  // validation code for formik
  const formValidate = (LocalFields: any) => {
    let errors: any = {};

    if (!LocalFields.supplierExistOrNot) {
      errors.supplierExistOrNot = "supplierExistOrNot is required";
    }
    if (
      LocalFields.supplierExistOrNot !== "true" &&
      !LocalFields.supplierAwareness
    ) {
      errors.supplierAwareness = "supplierAwareness is required";
    }
    if (!LocalFields.supplierDependent) {
      errors.supplierDependent = "supplierDependent is required";
    }
    return errors;
  };

  const getUserName = (
    supplierExistOrNot: string,
    supplierAwareness: string,
    supplierDependent: string
  ): string => {
    if (supplierExistOrNot === "") return "";

    // supplierExistOrNot === "true"
    if (supplierExistOrNot === "true" && supplierDependent === "true") return "Superior";
    if (supplierExistOrNot === "true" && supplierDependent === "false") return "Independent";

    // supplierExistOrNot === "false" && supplierAwareness === "true"
    if (supplierExistOrNot === "false" && supplierAwareness === "true" && supplierDependent === "true") return "Dependent";
    if (supplierExistOrNot === "false" && supplierAwareness === "true" && supplierDependent === "false") return "Inferior";

    // supplierExistOrNot === "false" && supplierAwareness === "false"
    if (supplierExistOrNot === "false" && supplierAwareness === "false" && supplierDependent === "true") return "Superior";
    if (supplierExistOrNot === "false" && supplierAwareness === "false" && supplierDependent === "false") return "Independent";

    return "";
  };

  // formik instance declaration
  const formik = useFormik({
    initialValues: LocalFields,
    validate: formValidate,
    validateOnMount: true,
    onSubmit: (data) => {
      if (data.supplierExistOrNot === "true") {
        data.supplierAwareness = "";
      }

      const userName = getUserName(
        data.supplierExistOrNot as string,
        data.supplierAwareness as string,
        data.supplierDependent as string
      );

      dispatch({ type: SET_POWER_POSITION, payload: userName });
      dispatch(savePowerPosition(data));
      powerPositionIdHandler(userName);
    },
  });

  const { supplierExistOrNot, supplierAwareness, supplierDependent } =
    formik.values;

  // setting data from redux store like pre filled data
  useEffect(() => {
    formik.setValues({ ...formik.values, ...powerPostionData });
  }, [powerPostionData]);

  // enable/disable the submit buttons depends on errors
  useEffect(() => {
    if (formik) {
      if (Object.keys(formik.errors || {}).length > 0) {
        setIsSubmitDisabled(true);
      } else {
        setIsSubmitDisabled(false);
      }
    }
  }, [formik]);

  // setting the formik reference from parent to child
  useEffect(() => {
    setRefInstance(formik);
  }, [formik]);

  const showSupplierAwareness =
  supplierExistOrNot !== "" && supplierExistOrNot !== "true";

const showSupplierDependent =
  (supplierExistOrNot !== "" || supplierAwareness !== "") &&
  (supplierExistOrNot === "true" ||
    (supplierAwareness !== "" &&
      (supplierAwareness === "true" || supplierAwareness === "false")));

  return (
    <div className="powerPositionContainer">
      <div className="power-position-questionaire-header">
        Please select the answers to following questions:
      </div>
      <form>
        <div className="row">
          <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 questionBox">
            <div className="row marginCSS">
              <div className="col-lg-2 col-md-4 col-sm-12 radioBoxStyle">
                <label>
                  <input
                    type="radio"
                    name="supplierExistOrNot"
                    value={"true"}
                    checked={
                      supplierExistOrNot !== "" && supplierExistOrNot === "true"
                    }
                    onChange={(e) =>
                      formik.setFieldValue("supplierExistOrNot", "true")
                    }
                    style={{ accentColor: "#004A96" }}
                    className=" radioIconStyle"
                  />

                  <span className="radioLabel">Yes</span>
                </label>
                <label className="">
                  <input
                    type="radio"
                    name="supplierExistOrNot"
                    value={"false"}
                    checked={
                      supplierExistOrNot !== "" &&
                      supplierExistOrNot === "false"
                    }
                    onChange={(e) =>
                      formik.setFieldValue("supplierExistOrNot", "false")
                    }
                    style={{ accentColor: "#004A96" }}
                    className=" radioIconStyle"
                  />
                  <span className="radioLabel">No</span>
                </label>
              </div>
              <div className="col-lg-10 col-md-8 col-sm-12">
                <div className="powerQuestion">
                  Assuming there is a shortage, would you have alternatives to
                  switch within a reasonable timespan?
                </div>
              </div>
            </div>

            {showSupplierAwareness && (
              <div className="row marginCSS">
                <div className="col-lg-2 col-md-4 col-sm-12 radioBoxStyle">
                  <label>
                    <input
                      type="radio"
                      name="supplierAwareness"
                      value={"true"}
                      checked={
                        supplierAwareness !== "" && supplierAwareness === "true"
                      }
                      onChange={() =>
                        formik.setFieldValue("supplierAwareness", "true")
                      }
                      style={{ accentColor: "#004A96" }}
                      className=" radioIconStyle"
                    />
                    <span className=" radioLabel">Yes</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="supplierAwareness"
                      value={"false"}
                      checked={
                        supplierAwareness !== "" &&
                        supplierAwareness === "false"
                      }
                      onChange={() =>
                        formik.setFieldValue("supplierAwareness", "false")
                      }
                      style={{ accentColor: "#004A96" }}
                      className=" radioIconStyle"
                    />
                    <span className="radioLabel">No</span>
                  </label>
                </div>
                <div className="col-lg-10 col-md-8 col-sm-12">
                  <div className="powerQuestion">
                    Does the supplier know that?
                  </div>
                </div>
              </div>
            )}

            {showSupplierDependent && (
              <div className="row  marginCSS">
                <div className="col-lg-2 col-md-4 col-sm-12 radioBoxStyle radioBoxStyle">
                  <label>
                    <input
                      type="radio"
                      name="supplierDependent"
                      value={"true"}
                      checked={
                        supplierDependent !== "" &&
                        supplierDependent === "true"
                      }
                      onChange={() =>
                        formik.setFieldValue("supplierDependent", "true")
                      }
                      style={{ accentColor: "#004A96" }}
                      className=" radioIconStyle"
                    />
                    <span className=" radioLabel">Yes</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="supplierDependent"
                      value={"false"}
                      checked={
                        supplierDependent !== "" &&
                        supplierDependent === "false"
                      }
                      onChange={() =>
                        formik.setFieldValue("supplierDependent", "false")
                      }
                      style={{ accentColor: "#004A96" }}
                      className=" radioIconStyle"
                    />
                    <span className=" radioLabel">No</span>
                  </label>
                </div>
                <div className="col-lg-10 col-md-8 col-sm-12">
                  <div className="powerQuestion">
                    Is the supplier dependent on you as a client or do you as a client have a significant advantages over other clients for the supplier?
{" "}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default PowerPositionQuestionnaire;
